import { render, staticRenderFns } from "./redpacket.vue?vue&type=template&id=1059e9af"
import script from "./redpacket.vue?vue&type=script&lang=js"
export * from "./redpacket.vue?vue&type=script&lang=js"
import style0 from "./redpacket.vue?vue&type=style&index=0&id=1059e9af&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports